import { useCallback, useEffect, useState } from 'react';
import { setDraftDetails as updateDraftDetails } from '../../../../data/setDraftDetails';
import getDraftDetails from '../../../../data/getDraftDetails';
import PropTypes from 'prop-types';

function DraftDetailToggle(props) {
  const [draftDetail, setDraftDetail] = useState(false);
  const [loading, setLoading] = useState(true);

  const loadDraftDetail = useCallback(async () => {
    setLoading(true);
    const draft = await getDraftDetails();

    if (draft.success) {
      setDraftDetail(Boolean(draft[props.draftDetailToToggle]));
    }

    setLoading(false);
  }, [props.draftDetailToToggle]);

  useEffect(() => {
    loadDraftDetail();
  }, [loadDraftDetail]);

  const updateDraft = useCallback(() => {
    updateDraftDetails({ [props.draftDetailToToggle]: !draftDetail }).then(result => {
      if (result.success) {
        setDraftDetail(!draftDetail);
      }
    });
  }, [draftDetail, props.draftDetailToToggle]);

  return (
    <div id="psf-draft-admin-disable-draft">

      <div className="custom-control custom-checkbox checkbox-xl">
        <input type="checkbox" className="custom-control-input" id={props.id} checked={draftDetail} onChange={updateDraft} disabled={loading} />
        <label className="custom-control-label" htmlFor={props.id}>
          {props.draftDetailLabel}
        </label>
      </div>

    </div>
  );
}

DraftDetailToggle.propTypes = {
  id: PropTypes.string.isRequired,
  draftDetailToToggle: PropTypes.string.isRequired,
  draftDetailLabel: PropTypes.string.isRequired,
};

export default DraftDetailToggle;